import React from "react";
import { Box, Typography, Paper } from "@mui/material";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
} from "recharts";
import { CircularProgress } from "@mui/material";

interface StockChartProps {
  data: { day: string; value: number }[];
  loading?: boolean;
}

const StockChart: React.FC<StockChartProps> = ({ data, loading = false }) => {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 3,
        borderRadius: "20px",
        background: "#f9fafb",
        border: "1px solid #e5e7eb",
        position: "relative", // for overlay
      }}
    >
      {}
      <Typography fontSize={18} fontWeight={600} mb={2}>
        Stock Movement Chart
      </Typography>

      {}
      {loading ? (
        <Box
          sx={{
            width: "100%",
            height: 320,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress color="success" />
        </Box>
      ) : (
        <Box sx={{ width: "100%", height: 320 }}>
          <ResponsiveContainer>
            <AreaChart data={data}>
              {}
              <defs>
                <linearGradient id="colorStock" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="#a3b84c" stopOpacity={0.8} />
                  <stop offset="95%" stopColor="#a3b84c" stopOpacity={0} />
                </linearGradient>
              </defs>

              {}
              <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#eee" />

              {}
              <XAxis dataKey="day" tick={{ fill: "#777" }} axisLine={false} tickLine={false} />
              <YAxis tick={{ fill: "#777" }} axisLine={false} tickLine={false} />

              {}
              <Tooltip />

              {}
              <Area
                type="monotone"
                dataKey="value"
                stroke="#a3b84c"
                strokeWidth={3}
                fillOpacity={1}
                fill="url(#colorStock)"
                dot={{
                  r: 5,
                  stroke: "#a3b84c",
                  strokeWidth: 2,
                  fill: "#c4d46b",
                }}
                activeDot={{ r: 7 }}
              />
            </AreaChart>
          </ResponsiveContainer>
        </Box>
      )}
    </Paper>
  );
};
export default StockChart;